export default "/_next/static/assets/images/sprite.6d079a1f68c7b83784635ea76b3a426d.svg";